import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  WeaponLimitation,
  WeaponMasteryMasterFeature,
} from "@dndModels";

import WeaponLimitInput from "@dndComponents/limitations/WeaponLimitInput";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props { 
  obj: WeaponMasteryMasterFeature;
  onChange: (changed: WeaponMasteryMasterFeature) => void;
  disabled?: boolean;
}

export default function WeaponMasteryMasterFeatureInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <WeaponLimitInput
          obj={myObj.weapon_limit}
          disabled={disabled}
          onChange={(changed: WeaponLimitation) => {
            const new_obj = myObj;
            new_obj.weapon_limit = changed.clone();
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <SelectObjectBox 
          name="Weapon Masteries" 
          data_type="weapon_mastery_property"
          values={myObj.wmp_ids} 
          disabled={disabled}
          multiple
          onChange={(changed: string[]) => {
            const new_ff = myObj;
            new_ff.wmp_ids = changed;
            setMyObj(new_ff);
            onChange(new_ff);
          }} 
        />
      </Grid>
    </Grid>
  );
}
